import { render, staticRenderFns } from "./FCA.vue?vue&type=template&id=500b2ff1&scoped=true"
import script from "./FCA.vue?vue&type=script&lang=js"
export * from "./FCA.vue?vue&type=script&lang=js"
import style0 from "./FCA.vue?vue&type=style&index=0&id=500b2ff1&prod&lang=scss&scoped=true"
import style1 from "./FCA.vue?vue&type=style&index=1&id=500b2ff1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b2ff1",
  null
  
)

export default component.exports